import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Modal, Button, Form } from 'react-bootstrap';
import * as yup from 'yup';
import { FluentDatePicker } from '../../../../components/FluentUI/Fluent-DatePicker';
import LoadingOverlay from '../../../../components/loading-ovelay/loading-overlay';
import DisplayAlert from "../tasks-comments/DisplayAlert/DisplayAlert";
import { ReopenTask } from '../../../../services/api/task-api';
import {
    checkInvalidFile,
    shortenFileName,
    browseFile,
    drop,
    deleteBrowseFile,
    dragOver,
    dragEnter,
    dragLeave,
    ToBase64
} from "../../../../util/file-helpers.js";
import { errorNotification, successNotification } from "../../../../redux/notifications";
import { useDispatch } from 'react-redux';
import '../tasks-reassign-panel/tasks-reassign-panel.scss';
import './task-reopen-panel.scss';

const TaskReopenPanel = ({ show, onHide, type, task, refreshTasks, labels }) => {
    const [comment, setComment] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertVariant, setAlertVariant] = useState("danger");
    const [alertMessage, setAlertMessage] = useState("");
    const [alertAction, setAlertAction] = useState("");
    const [sizeExceeded, setSizeExceeded] = useState("0");
    const dispatch = useDispatch();

    const reOpenSubmit = async (values) => {
        const convertedFiles = await Promise.all(
            selectedFiles.map(async (file) => {
                const result = await ToBase64(file);
                let mimetype = result.substr(result.indexOf(':') + 1, result.indexOf(';') - result.indexOf(':') - 1);
                let thedocAsBytes = result.split(',')[1];
                return { FileName: file.name, FileContentType: mimetype, FileByteArray: thedocAsBytes };
            })
        );

        let taskObj = {
            TaskId: values.Id,
            TaskType: task.TaskType,
            Comment: comment,
            Due: values.Due,
            taskCommentFiles: convertedFiles?.length > 0 ? convertedFiles : []
        }

        await ReopenTask(taskObj)
            .then((res) => {
                if (res.status === 200 && res.data) {
                    dispatch(successNotification({
                        header: `${labels?.TaskSingular ?? "Task"} Re-opened`,
                        message: `The ${labels?.TaskSingular ?? "task"} "${task.Name}" has been Re-opened successfully`
                    }));
                    onHide();
                    refreshTasks();
                } else {
                    dispatch(errorNotification({
                        header: `${labels?.TaskSingular ?? "Task"} Re-opened failed`,
                        message: `The ${labels?.TaskSingular ?? "task"} could not be Re-opened`
                    }));
                    onHide();
                    refreshTasks();
                }
            })
            .catch((err) => {
                console.log(err);
                onHide();
                dispatch(errorNotification({
                    header: `${labels.TaskSingular ?? "Task"} Re-opened failed`,
                    message: err
                }));
            });
    };

    const handleFileCheck = (file) => {
        const alertInfo = checkInvalidFile(file);
        if (!alertInfo.validFile) {
            setAlertVariant(alertInfo.alertVariant);
            setAlertAction(alertInfo.alertAction);
            setAlertMessage(alertInfo.alertMessage);
            setSizeExceeded(alertInfo.sizeExceeded);
            setShowAlert(alertInfo.showAlert);
        }
        return alertInfo.validFile;
    };

    useEffect(() => {
        let timer;
        if (showAlert) {
            timer = setTimeout(() => setShowAlert(false), 5000);
        };
        return () => clearTimeout(timer);
    }, [showAlert]);

    return (
        <Modal show={show} onHide={onHide} className="task-reopen-panel" centered>
            <Modal.Header closeButton>
                <Modal.Title className="reopen-title">
                    Confirmation &middot; Re-open {labels.TaskSingular ?? "Task"}
                    <h3 className="reopen-subheading">&ldquo;{task.Name}&rdquo;</h3>
                </Modal.Title>
            </Modal.Header>
            <div className="select-member-divider-line"></div>
            <Modal.Body>
                <div>
                    <LoadingOverlay area="tasks-reassign-panel"/>
                    <div className='reopen-description'>
                        The {labels.TaskSingular ?? "Task"}, &ldquo;{task.Name}&rdquo;, will be Re-opened. Please set a new Due Date below.
                    </div>
                    <Formik
                        validationSchema={yup.object({
                            Due: yup.date().typeError("Enter A Valid Date").required("End Date Required"),
                        })}
                        onSubmit={(values) => reOpenSubmit(values)}
                        initialValues={task}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                            setFieldValue,
                            isSubmitting
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="due-date-calendar">
                                    <Form.Label>Due Date</Form.Label>
                                    <FluentDatePicker
                                        id="Due"
                                        name="Due"
                                        placeholder="Click to select a end date"
                                        value={values.Due ? new Date(values.Due) : null}
                                        onChange={(value) => setFieldValue("Due", value)}
                                        minDate={new Date()}
                                        isInvalid={touched.Due && errors.Due !== undefined}
                                        feedback={errors.Due}
                                    />
                                </Form.Group>
                                <Form.Group className='re-open-comment'>
                                    <Form.Label>Comments (optional)</Form.Label>
                                    <Form.Control
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        as="textarea" rows="3" placeholder="Enter Comment"
                                    />
                                </Form.Group>
                                <Form.Group>
                                   <div
                                        onDrop={(e) => drop(e, selectedFiles, setSelectedFiles, handleFileCheck)}
                                        onDragOver={dragOver}
                                        onDragEnter={dragEnter}
                                        onDragLeave={dragLeave}
                                    >
                                        <div className={"upload-file-box " + (showAlert ? " invalid-border" : "")}>
                                            <Form.Control
                                                className="browse-btn-hidden"
                                                type="file"
                                                multiple
                                                onChange={(e) => browseFile(e, selectedFiles, setSelectedFiles, handleFileCheck)}
                                            />
                                            <Button className="browse-file-btn add-attachment-btn"></Button>
                                            {   selectedFiles?.map((file) =>
                                                    <div className="single-file">
                                                        <span className="file-name">{shortenFileName(file.name)}</span>
                                                        <Button onClick={(e) => deleteBrowseFile(e, file.name, selectedFiles, setSelectedFiles)} className="delete-file-btn">
                                                            x
                                                        </Button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    {   showAlert &&
                                        <DisplayAlert showAlert={showAlert} alertMessage={alertMessage} sizeExceeded={sizeExceeded} />
                                    }
                                </Form.Group>
                                <div className="action-buttons">
                                    <Button className="btn-wide btn-outlined" onClick={onHide} variant="primary">
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        className="btn-wide"
                                        variant="primary"
                                        disabled={isSubmitting}
                                    >
                                        Re-open {labels.TaskSingular ?? "Task"}
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal.Body>
        </Modal>
    )
}

TaskReopenPanel.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    type: PropTypes.string.isRequired,
    task: PropTypes.object.isRequired,
    refreshTasks: PropTypes.func,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
        ProjectSingularPossessive: PropTypes.string,
        ProjectPluralPossessive: PropTypes.string,
        TaskSingular: PropTypes.string,
        TaskPlural: PropTypes.string,
        TaskSingularPossessive: PropTypes.string,
        TaskPluralPossessive: PropTypes.string,
        FormSingular: PropTypes.string,
        FormPlural: PropTypes.string,
        FormSingularPossessive: PropTypes.string,
        FormPluralPossessive: PropTypes.string,
    }),
};

export default TaskReopenPanel;
